import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  phoneNumber: '',
  tnc: true,
  otpCode: '',
  isAuthorized: false,

  sendOtp: {
    loading: false,
    error: null,
    success: false,
  },
  verifyOtp: {
    loading: false,
    error: null,
    success: false,
  },
  userDetails: {
    data: null,
    error: null,
    loading: false,
    success: false,
  },
  updateUserDetails: {
    loading: false,
    error: null,
    success: false,
  },
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    handlePhoneNumberChange: (state, action) => {
      state.phoneNumber = action.payload
    },
    handleTnCChange: (state, action) => {
      state.tnc = action.payload
    },
    handleOtpCodeChange: (state, action) => {
      state.otpCode = action.payload
    },

    // Send OTP
    sendOtpRequest: (state, action) => {
      state.sendOtp = {
        ...state.sendOtp,
        loading: true,
        success: false,
      }
    },
    sendOtpSuccess: (state, action) => {
      state.sendOtp = {
        ...state.sendOtp,
        loading: false,
        success: true,
        error: null,
      }
    },
    sendOtpFailure: (state, action) => {
      state.sendOtp = {
        ...state.sendOtp,
        loading: false,
        success: false,
        error: action.payload,
      }
    },

    resetSendOtp: (state, action) => {
      state.sendOtp = {
        loading: false,
        error: null,
        success: false,
      }
    },

    // Verify OTP
    verifyOtpRequest: (state, action) => {
      state.verifyOtp = {
        ...state.verifyOtp,
        loading: true,
        success: false,
      }
    },
    verifyOtpSuccess: (state, action) => {
      state.verifyOtp = {
        ...state.verifyOtp,
        loading: false,
        success: true,
        error: null,
      }
    },
    verifyOtpFailure: (state, action) => {
      state.verifyOtp = {
        ...state.verifyOtp,
        loading: false,
        success: false,
        error: action.payload,
      }
    },

    //Authenticate User
    authenticateUserRequest: (state, action) => {
      state.userDetails = {
        ...state.userDetails,
        loading: true,
      }
    },
    authenticateUserSuccess: (state, action) => {
      state.userDetails = {
        ...state.userDetails,
        loading: false,
        success: true,
        data: { ...state.userDetails.data, ...action.payload },
      }
      state.isAuthorized = true
      state.phoneNumber = action.payload.contact_no
    },
    authenticateUserError: (state, action) => {
      state.userDetails = {
        ...state.userDetails,
        loading: false,
        success: false,
        error: action.payload,
      }
    },
    appendUserDetails: (state, action) => {
      state.userDetails = {
        ...state.userDetails,
        data: { ...state.userDetails.data, ...action.payload },
      }
    },

    //Update User Details
    updateUserRequest: (state, action) => {
      state.updateUserDetails = {
        ...state.updateUserDetails,
        loading: true,
        error: null,
        success: false,
      }
    },
    updateUserSuccess: (state, action) => {
      state.updateUserDetails = {
        ...state.updateUserDetails,
        loading: false,
        success: true,
      }
    },
    updateUserError: (state, action) => {
      state.updateUserDetails = {
        ...state.updateUserDetails,
        loading: false,
        success: false,
        error: action.payload,
      }
    },
    resetAuth: (state) => {
      state.verifyOtp = {
        loading: false,
        error: null,
        success: false,
        message: null,
        userDetails: null,
      }
      state.userDetails = {
        loading: false,
        error: null,
        success: false,
        data: null,
      }
      state.sendOtp = {
        loading: false,
        error: null,
        success: false,
        message: null,
      }
    },
  },
})

export const {
  handleOtpCodeChange,
  handlePhoneNumberChange,
  handleResendTimerChange,
  handleTnCChange,

  //Send OTP
  sendOtpRequest,
  sendOtpSuccess,
  sendOtpFailure,
  resetSendOtp,

  //Verify OTP
  verifyOtpRequest,
  verifyOtpSuccess,
  verifyOtpFailure,

  //Authenticate User
  authenticateUserRequest,
  authenticateUserSuccess,
  authenticateUserError,
  appendUserDetails,

  //Update user
  updateUserRequest,
  updateUserSuccess,
  updateUserError,

  // Reset Auth(Persisted) data
  resetAuth,
} = authSlice.actions

export default authSlice.reducer
